import { SortingState, OnChangeFn } from '@tanstack/react-table'
import { create } from 'zustand'

export type InventoryStatusFilter = 'all' | 'active' | 'deleted'

interface InventoriesTableState {
  page: number
  pageSize: number
  sorting: SortingState
  searchTerm: string
  statusFilter: InventoryStatusFilter

  setPage: (page: number) => void
  setPageSize: (pageSize: number) => void
  setSorting: OnChangeFn<SortingState>
  setSearchTerm: (searchTerm: string) => void
  setStatusFilter: (statusFilter: InventoryStatusFilter) => void
  clearFilters: () => void

  handlePageChange: (newPage: number) => void
  handlePageSizeChange: (newPageSize: number) => void
}

export const useInventoriesTableStore = create<InventoriesTableState>(
  (set) => ({
    page: 1,
    pageSize: 20,
    sorting: [],
    searchTerm: '',
    statusFilter: 'all',

    setPage: (page) => set({ page }),
    setPageSize: (pageSize) => set({ pageSize }),
    setSorting: (updaterOrValue) =>
      set((state) => ({
        sorting:
          typeof updaterOrValue === 'function'
            ? updaterOrValue(state.sorting)
            : updaterOrValue,
      })),
    setSearchTerm: (searchTerm) => set({ searchTerm, page: 1 }),
    setStatusFilter: (statusFilter) => set({ statusFilter, page: 1 }),
    clearFilters: () => set({ searchTerm: '', statusFilter: 'all', page: 1 }),

    handlePageChange: (newPage) => set({ page: newPage }),
    handlePageSizeChange: (newPageSize) =>
      set({ pageSize: newPageSize, page: 1 }),
  })
)
